import ParticleBackground from '../components/ParticleBackground'
import DeviceInfoPanel from '../components/DeviceInfoPanel'

export default function DeviceInfoPage() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-void-black">
      <ParticleBackground />
      <div className="absolute inset-0 bg-gradient-nebula opacity-30" />
      <div className="relative z-10">
        <DeviceInfoPanel />
      </div>
    </div>
  )
}
